import React, { useState } from 'react';

const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL || '';
const API_BASE = `${SERVER_BASE_URL}/api`;

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password.');
      return;
    }
    setLoading(true); setError('');
    try {
      const res  = await fetch(`${API_BASE}/auth/login`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ username: username.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Login failed.'); }
      else {
        // Store token and user in localStorage
        localStorage.setItem('rm_token', data.token);
        localStorage.setItem('rm_user',  JSON.stringify(data.user));
        onLogin(data.user, data.token);
      }
    } catch { setError('Could not connect to server.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="app">
      <div className="bg-layer" />

      <header className="header">
        <div className="header-inner">
          <img src="/rm-logo.png" alt="RM Metals" className="logo-img" />
          <div className="header-text">
            <h1 className="site-title">RM Trucking</h1>
            <p className="site-subtitle">RM METALS — DIVISION OF RM CREATIONS INC.</p>
          </div>
        </div>
      </header>

      <main className="main">
        <div className="login-container">
          <div className="login-card">

            <div className="login-header">
              <div className="login-icon">🔐</div>
              <div className="login-title">Sign In</div>
              <div className="login-subtitle">Enter your credentials to access the system</div>
            </div>

            <form onSubmit={handleLogin} className="login-form">
              <div className="login-field">
                <label className="login-label">USERNAME</label>
                <input
                  type="text"
                  className="login-input"
                  placeholder="Enter your username"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  autoFocus
                  autoComplete="username"
                  disabled={loading}
                />
              </div>

              <div className="login-field">
                <label className="login-label">PASSWORD</label>
                <div className="login-password-row">
                  <input
                    type={showPass ? 'text' : 'password'}
                    className="login-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="current-password"
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="login-show-pass"
                    onClick={() => setShowPass(!showPass)}
                    tabIndex={-1}
                  >
                    {showPass ? '🙈' : '👁'}
                  </button>
                </div>
              </div>

              {error && (
                <div className="message error-msg">
                  <span className="msg-icon">⚠</span> {error}
                </div>
              )}

              <button type="submit" className="login-btn" disabled={loading}>
                {loading
                  ? <><span className="spinner" /> Signing in…</>
                  : 'Sign In →'
                }
              </button>
            </form>

          </div>
        </div>
      </main>

      <footer className="footer">
        RM Metals — Division of RM Creations Inc. · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
